import { gql } from '@apollo/client';

import { CHALLENGE_APPLICATION, TEAM } from './challenge-application';
import { COMPANY_BASIC, COMPANY_INFO } from './company';
import { CRITERIA, CRITERIA_RESULT } from './criteria';
import { FILE } from './upload';
import { USER_BASICS } from './user';

export const STAGE = gql`
  fragment stage on Stage {
    id
    name
    description
    startAt
    endAt
    votingType
    scheduleHidden
    state
    createdAt
    updatedAt
    orderNumber
    applications {
      ...challengeApplication
    }
  }
`;

export const STAGE_BASICS = gql`
  fragment stageBasics on Stage {
    id
    name
    description
    orderNumber
    state
  }
`;

export const UPDATE_STAGES = gql`
  mutation UpdateStages($challengeId: ID!, $inputs: [UpdateStageInput]!) {
    updateStages(challengeId: $challengeId, inputs: $inputs) {
      ...stage
    }
  }
  ${STAGE}
  ${CHALLENGE_APPLICATION}
  ${TEAM}
  ${USER_BASICS}
  ${FILE}
  ${COMPANY_BASIC}
  ${COMPANY_INFO}
  ${CRITERIA}
  ${CRITERIA_RESULT}
`;
